import { FC, useEffect, useState } from "react";

export interface ScrollDownIndicatorProps {
  targetId?: string;
  className?: string;
}

const ScrollDownIndicator: FC<ScrollDownIndicatorProps> = ({
  targetId = "why-choose-us",
  className = "",
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY < window.innerHeight * 0.35);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    document.getElementById(targetId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll down to explore more"
      className={`bcr-scroll-indicator group flex flex-col items-center gap-3 ${className}`}
    >
      <span className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.3em] text-white/80 group-hover:text-white transition-colors bcr-scroll-text-glow">
        Scroll to explore
      </span>

      {/* Mouse / scroll wheel style */}
      <span className="relative flex flex-col items-center">
        <span className="bcr-scroll-pulse-ring absolute -inset-3 rounded-full" />
        <span className="relative w-7 h-11 sm:w-8 sm:h-[3.25rem] rounded-full border-2 border-white/70 group-hover:border-white bg-white/10 backdrop-blur-md flex items-start justify-center pt-2 overflow-hidden shadow-[0_0_20px_rgba(255,255,255,0.15)] group-hover:shadow-[0_0_28px_rgba(255,255,255,0.35)] transition-all duration-300">
          <span className="bcr-scroll-wheel-dot w-1 h-2 sm:w-1.5 sm:h-2.5 rounded-full bg-white" />
        </span>
      </span>

      {/* Double chevron */}
      <span className="flex flex-col items-center -mt-1 text-white/90">
        <svg
          className="w-5 h-5 animate-bounce-scroll"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
        <svg
          className="w-5 h-5 -mt-3 animate-bounce-scroll-delayed opacity-60"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </span>
    </button>
  );
};

export default ScrollDownIndicator;
